export default function Topbar({ title, subtitle, menuButton }) {
  return (
    <header className="sticky top-0 z-40 bg-white border-b border-gray-200 px-4 md:px-6 py-3.5 flex items-center justify-between gap-4">
      <div className="flex items-center gap-3">
        {menuButton}
        <div>
          <h1 className="text-lg md:text-xl font-bold text-gray-900">{title}</h1>
          <p className="text-xs md:text-sm text-gray-500">{subtitle}</p>
        </div>
      </div>
    </header>
  );
}
